<template>
  <ConfirmDialog>
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div
        class="bg-white flex flex-col items-center p-6 lg:p-8 surface-overlay rounded-2xl text-primary">
        <span class="font-bold text-2xl block mb-2 mt-4">
          {{ $t(message.header) }}
        </span>
        <p
          v-if="message.message"
          class="mb-0 text-center"
          v-html="message.message" />
        <div class="grid grid-cols-2 min-w-[250px] gap-4 mt-4">
          <BaseButton
            label="Cancel"
            rounded
            outlined
            class="w-full"
            @click="rejectCallback">
            {{ $t('No') }}
          </BaseButton>
          <BaseButton
            label="Save"
            rounded
            class="w-8rem"
            @click="acceptCallback">
            {{ $t('Yes') }}
          </BaseButton>
        </div>
      </div>
    </template>
  </ConfirmDialog>
</template>

<script setup>
  import ConfirmDialog from 'primevue/confirmdialog';
  import BaseButton from '@/components/UI/BaseButton.vue';
</script>
